// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__font-s-10___xMH2o {
  font-size: 10px !important;
}

.Header-module__font-s-12___aJWVr {
  font-size: 12px !important;
}

.Header-module__font-s-13___gkHOY {
  font-size: 13px !important;
}

.Header-module__font-s-14___XG_m8 {
  font-size: 14px !important;
}

.Header-module__font-s-15___UH4yc {
  font-size: 15px !important;
}

.Header-module__font-s-16___fyO3T {
  font-size: 16px !important;
}

.Header-module__font-s-18___DOscy {
  font-size: 18px !important;
}

.Header-module__font-s-20___wIy2u {
  font-size: 20px !important;
}

.Header-module__font-s-22___QZFDT {
  font-size: 22px !important;
}

.Header-module__font-s-28___UQXsi {
  font-size: 28px !important;
}

.Header-module__font-w-400___UkBfH {
  font-weight: 400 !important;
}

.Header-module__font-w-500___rh5D5 {
  font-weight: 500 !important;
}

.Header-module__font-w-600___Ci_LK {
  font-weight: 600 !important;
}

.Header-module__font-w-700___ebhfy {
  font-weight: 700 !important;
}

.Header-module__p-5___cmagZ {
  padding: 5px !important;
}

.Header-module__p-12___bfSpN {
  padding: 12px !important;
}

.Header-module__p-16___SI3p_ {
  padding: 16px !important;
}

.Header-module__p-30___Sh8wJ {
  padding: 30px !important;
}

.Header-module__p-b-0___uLkib {
  padding-bottom: 0 !important;
}

.Header-module__p-b-5___GHjyU {
  padding-bottom: 5px !important;
}

.Header-module__p-b-10___NS6K8 {
  padding-bottom: 10px !important;
}

.Header-module__p-b-12___E8fQa {
  padding-bottom: 12px !important;
}

.Header-module__p-b-16___WdwYy {
  padding-bottom: 16px !important;
}

.Header-module__p-b-18___XSHol {
  padding-bottom: 18px !important;
}

.Header-module__p-b-20___SyPFt {
  padding-bottom: 20px !important;
}

.Header-module__p-b-25___LGs7G {
  padding-bottom: 25px !important;
}

.Header-module__p-b-30___VUrZe {
  padding-bottom: 30px !important;
}

.Header-module__p-b-50___cq_mX {
  padding-bottom: 50px !important;
}

.Header-module__p-t-0___j9440 {
  padding-top: 0 !important;
}

.Header-module__p-t-12___xhtII {
  padding-top: 12px !important;
}

.Header-module__p-t-16___XkPZp {
  padding-top: 16px !important;
}

.Header-module__p-t-18___u9Rtz {
  padding-top: 18px !important;
}

.Header-module__p-t-20___IxE2S {
  padding-top: 20px !important;
}

.Header-module__p-t-30___Bwnn2 {
  padding-top: 30px !important;
}

.Header-module__p-t-40___ST41P {
  padding-top: 40px !important;
}

.Header-module__p-t-50___xMcVv {
  padding-top: 50px !important;
}

.Header-module__p-l-20___xQZ4m {
  padding-left: 20px !important;
}

.Header-module__p-l-30___CgB4v {
  padding-left: 30px !important;
}

.Header-module__p-l-40___gzGfE {
  padding-left: 40px !important;
}

.Header-module__p-r-16___GsnKV {
  padding-right: 16px !important;
}

.Header-module__p-r-20___nVw_0 {
  padding-right: 20px !important;
}

.Header-module__p-r-30___tf9lS {
  padding-right: 30px !important;
}

.Header-module__p-r-50___SOtL_ {
  padding-right: 50px !important;
}

.Header-module__p-r-60___M3pn8 {
  padding-right: 60px !important;
}

.Header-module__m-b-1___W2RUT {
  margin-bottom: 1px !important;
}

.Header-module__m-b-2___nyqlh {
  margin-bottom: 2px !important;
}

.Header-module__m-b-6___moiij {
  margin-bottom: 6px !important;
}

.Header-module__m-b-8___MTq9e {
  margin-bottom: 8px !important;
}

.Header-module__m-b-10___rz7pv {
  margin-bottom: 10px !important;
}

.Header-module__m-b-14___TwmcL {
  margin-bottom: 14px !important;
}

.Header-module__m-b-16___FiiEK {
  margin-bottom: 16px !important;
}

.Header-module__m-b-20___maA8s {
  margin-bottom: 20px !important;
}

.Header-module__m-b-22___DR8on {
  margin-bottom: 22px !important;
}

.Header-module__m-b-24___MV7m9 {
  margin-bottom: 24px !important;
}

.Header-module__m-b-30___wMnFj {
  margin-bottom: 30px !important;
}

.Header-module__m-b-32___e_F1J {
  margin-bottom: 32px !important;
}

.Header-module__m-b-40___qhDfx {
  margin-bottom: 40px !important;
}

.Header-module__m-t-2___IMZ2c {
  margin-top: 2px !important;
}

.Header-module__m-t-3___EyncI {
  margin-top: 3px !important;
}

.Header-module__m-t-4___gMGZD {
  margin-top: 4px !important;
}

.Header-module__m-t-5___G_WB1 {
  margin-top: 5px !important;
}

.Header-module__m-t-8___w3TbQ {
  margin-top: 8px !important;
}

.Header-module__m-t-10___nlwmQ {
  margin-top: 10px !important;
}

.Header-module__m-t-15___IE6dP {
  margin-top: 15px !important;
}

.Header-module__m-t-16___plD69 {
  margin-top: 16px !important;
}

.Header-module__m-t-20___a9q8I {
  margin-top: 20px !important;
}

.Header-module__m-t-22___r2LQ3 {
  margin-top: 22px !important;
}

.Header-module__m-t-30___VdU9z {
  margin-top: 30px !important;
}

.Header-module__m-t-32___YSBh9 {
  margin-top: 32px !important;
}

.Header-module__m-l-auto___z_cwF {
  margin-left: auto !important;
}

.Header-module__m-l-4___a78bg {
  margin-left: 4px !important;
}

.Header-module__m-l-5___UxcSd {
  margin-left: 5px !important;
}

.Header-module__m-l-6___e2833 {
  margin-left: 6px !important;
}

.Header-module__m-l-8___J7nJe {
  margin-left: 8px !important;
}

.Header-module__m-l-10___m5rOI {
  margin-left: 10px !important;
}

.Header-module__m-l-16___X9OWn {
  margin-left: 16px !important;
}

.Header-module__m-l-20___sD81d {
  margin-left: 20px !important;
}

.Header-module__m-l-24___d7wWI {
  margin-left: 24px !important;
}

.Header-module__m-l-30___V7DwS {
  margin-left: 30px !important;
}

.Header-module__m-l-35___QvYm2 {
  margin-left: 35px !important;
}

.Header-module__m-l-40___J70LO {
  margin-left: 40px !important;
}

.Header-module__m-r-8___Zk8Du {
  margin-right: 8px !important;
}

.Header-module__m-r-10___yBTsr {
  margin-right: 10px !important;
}

.Header-module__m-r-16___J2NSX {
  margin-right: 16px !important;
}

.Header-module__m-r-20____mJax {
  margin-right: 20px !important;
}

.Header-module__m-r-24___EE2J_ {
  margin-right: 24px !important;
}

.Header-module__m-r-30___Btmfm {
  margin-right: 30px !important;
}

.Header-module__m-r-40___xynn2 {
  margin-right: 40px !important;
}

.Header-module__border-r-3___Mi2o3 {
  border-radius: 3px !important;
}

.Header-module__border-r-4___bt9pI {
  border-radius: 4px !important;
}

.Header-module__border-r-6___mmls_ {
  border-radius: 6px !important;
}

.Header-module__border-r-10___CcYwb {
  border-radius: 10px !important;
}

.Header-module__border-r-12___DGeRv {
  border-radius: 12px !important;
}

.Header-module__border-r-16___PSyfv {
  border-radius: 16px !important;
}

.Header-module__border-r-50___mII_D {
  border-radius: 50% !important;
}

.Header-module__primary-border___Ijkp8 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-b___q80F8 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-t___Rt4kU {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-l___tAd65 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-r___IRnhw {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__secondary-border___GmEqg {
  border: 1px solid #637768;
}

.Header-module__secondary-border-b___mkSrB {
  border-bottom: 1px solid #637768;
}

.Header-module__secondary-border-t___bQPjS {
  border-top: 1px solid #637768;
}

.Header-module__secondary-border-l___eeqs6 {
  border-left: 1px solid #637768;
}

.Header-module__secondary-border-r___m7fQj {
  border-right: 1px solid #637768;
}

.Header-module__gap-0___VV844 {
  gap: 0 !important;
}

.Header-module__gap-2___rHayV {
  gap: 2px !important;
}

.Header-module__gap-4___e9DFS {
  gap: 4px !important;
}

.Header-module__gap-5___wiPFh {
  gap: 5px !important;
}

.Header-module__gap-6___lqGmn {
  gap: 6px !important;
}

.Header-module__gap-8___CpT_f {
  gap: 8px !important;
}

.Header-module__gap-10___g4Eko {
  gap: 10px !important;
}

.Header-module__gap-12___kEcX1 {
  gap: 12px !important;
}

.Header-module__gap-14___P7p4W {
  gap: 14px !important;
}

.Header-module__gap-16___PFxAX {
  gap: 16px !important;
}

.Header-module__gap-18___GHYAh {
  gap: 18px !important;
}

.Header-module__gap-20___UM4vh {
  gap: 20px !important;
}

.Header-module__gap-24___fTvQN {
  gap: 24px !important;
}

.Header-module__gap-26___OhKR0 {
  gap: 26px !important;
}

.Header-module__gap-30___Ht1bg {
  gap: 30px !important;
}

.Header-module__gap-32___PS58g {
  gap: 32px !important;
}

.Header-module__gap-40___LVR5v {
  gap: 40px !important;
}

.Header-module__gap-50___AEotQ {
  gap: 50px !important;
}

.Header-module__flex-1___x3qDH {
  flex: 1;
}

.Header-module__flex-none___wbOPq {
  flex: none !important;
}

.Header-module__flex-column___nDPPu {
  display: flex;
  flex-direction: column !important;
}

.Header-module__flex-row___RopcY {
  display: flex;
  flex-direction: row !important;
}

.Header-module__vertically-centered___vhSxs {
  display: flex;
  align-items: center !important;
}

.Header-module__horizontally-centered___d_Yn6 {
  display: flex;
  justify-content: center !important;
}

.Header-module__horizontally-end___XzgiW {
  display: flex;
  justify-content: end !important;
}

.Header-module__vertically-start___qm6p3 {
  display: flex;
  align-items: start !important;
}

.Header-module__space-between___kBNcU {
  display: flex;
  justify-content: space-between !important;
}

.Header-module__flex-wrap___qdItr {
  flex-wrap: wrap !important;
}

.Header-module__height-100___vM7m7 {
  height: 100%;
}

.Header-module__width-50___GwBBG {
  width: 50% !important;
}

.Header-module__width-100___Ds8gv {
  width: 100%;
}

.Header-module__cursor-pointer___JACtv {
  cursor: pointer;
}

.Header-module__cursor-not-allowed___CYDzn {
  cursor: not-allowed !important;
}

.Header-module__absolute-centered___sGDR5 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Header-module__absolute___zaeki {
  position: absolute;
}

.Header-module__relative___W7kVU {
  position: relative;
}

.Header-module__fixed___BOPg1 {
  position: fixed;
}

.Header-module__visible___HDQi7 {
  opacity: 1;
}

.Header-module__invisible___khVaH {
  opacity: 0;
}

.Header-module__col-90___fosfH {
  width: 90% !important;
}

.Header-module__col-auto___3wAaL {
  width: auto !important;
}

.Header-module__medical-tabs___VamLt {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Header-module__medical-table-new___wbkPn {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Header-module__medical-table-new___wbkPn:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Header-module__medical-table-new___wbkPn::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Header-module__medical-table-new___wbkPn::-webkit-scrollbar-track {
  display: none;
}
.Header-module__medical-table-new___wbkPn.Header-module__no-pagination___HHTpv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Header-module__medical-table-new___wbkPn.Header-module__no-pagination___HHTpv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Header-module__medical-table-new___wbkPn.Header-module__no-pagination___HHTpv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Header-module__medical-table-new___wbkPn.Header-module__no-pagination___HHTpv::-webkit-scrollbar-track {
  display: none;
}

.Header-module__medical-table-empty___bjM4S {
  padding: 14px 40px !important;
}

.Header-module__icon-btn___dosOP {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Header-module__search-icon___bhTTO {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Header-module__disable-select___cRmUi {
  user-select: none;
}

.Header-module__break-word___VjUbm {
  word-break: break-word;
}

.Header-module__popup-clear-btn___ZSdaC {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Header-module__scroll-m-b-20___sizLR {
  scroll-margin-bottom: 20px;
}

.Header-module__container___LLWyQ {
  flex: 1;
  justify-content: space-between;
}
.Header-module__container___LLWyQ .Header-module__title___op45E {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 27px;
  color: #375844;
  flex: 1;
}
.Header-module__container___LLWyQ .Header-module__buttonWrapper___yf0v8 {
  min-width: 118px;
  line-height: 17px;
  color: #375844;
}
.Header-module__container___LLWyQ .Header-module__buttonWrapper___yf0v8 .Header-module__icon___o2Nz3 {
  width: 12px;
  height: 13px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DevicesFragment/components/OrderHistoryList/Header/Header.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,8BAAA;AA8pBF;AA5pBE;EEoBA,+BApBO;EAqBP,gBAFmD;EFjBjD,iBAAA;EACA,cAAA;EACA,OAAA;AA+pBJ;AA5pBE;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AA8pBJ;AA5pBI;EACE,WAAA;EACA,YAAA;AA8pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  justify-content: space-between;\n\n  .title {\n    @include get-font($roboto);\n    line-height: 27px;\n    color: get-color(greenNew, dark);\n    flex: 1;\n  }\n\n  .buttonWrapper {\n    min-width: 118px;\n    line-height: 17px;\n    color: get-color(greenNew, dark);\n\n    .icon {\n      width: 12px;\n      height: 13px;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Header-module__font-s-10___xMH2o`,
	"fontS12": `Header-module__font-s-12___aJWVr`,
	"fontS13": `Header-module__font-s-13___gkHOY`,
	"fontS14": `Header-module__font-s-14___XG_m8`,
	"fontS15": `Header-module__font-s-15___UH4yc`,
	"fontS16": `Header-module__font-s-16___fyO3T`,
	"fontS18": `Header-module__font-s-18___DOscy`,
	"fontS20": `Header-module__font-s-20___wIy2u`,
	"fontS22": `Header-module__font-s-22___QZFDT`,
	"fontS28": `Header-module__font-s-28___UQXsi`,
	"fontW400": `Header-module__font-w-400___UkBfH`,
	"fontW500": `Header-module__font-w-500___rh5D5`,
	"fontW600": `Header-module__font-w-600___Ci_LK`,
	"fontW700": `Header-module__font-w-700___ebhfy`,
	"p5": `Header-module__p-5___cmagZ`,
	"p12": `Header-module__p-12___bfSpN`,
	"p16": `Header-module__p-16___SI3p_`,
	"p30": `Header-module__p-30___Sh8wJ`,
	"pB0": `Header-module__p-b-0___uLkib`,
	"pB5": `Header-module__p-b-5___GHjyU`,
	"pB10": `Header-module__p-b-10___NS6K8`,
	"pB12": `Header-module__p-b-12___E8fQa`,
	"pB16": `Header-module__p-b-16___WdwYy`,
	"pB18": `Header-module__p-b-18___XSHol`,
	"pB20": `Header-module__p-b-20___SyPFt`,
	"pB25": `Header-module__p-b-25___LGs7G`,
	"pB30": `Header-module__p-b-30___VUrZe`,
	"pB50": `Header-module__p-b-50___cq_mX`,
	"pT0": `Header-module__p-t-0___j9440`,
	"pT12": `Header-module__p-t-12___xhtII`,
	"pT16": `Header-module__p-t-16___XkPZp`,
	"pT18": `Header-module__p-t-18___u9Rtz`,
	"pT20": `Header-module__p-t-20___IxE2S`,
	"pT30": `Header-module__p-t-30___Bwnn2`,
	"pT40": `Header-module__p-t-40___ST41P`,
	"pT50": `Header-module__p-t-50___xMcVv`,
	"pL20": `Header-module__p-l-20___xQZ4m`,
	"pL30": `Header-module__p-l-30___CgB4v`,
	"pL40": `Header-module__p-l-40___gzGfE`,
	"pR16": `Header-module__p-r-16___GsnKV`,
	"pR20": `Header-module__p-r-20___nVw_0`,
	"pR30": `Header-module__p-r-30___tf9lS`,
	"pR50": `Header-module__p-r-50___SOtL_`,
	"pR60": `Header-module__p-r-60___M3pn8`,
	"mB1": `Header-module__m-b-1___W2RUT`,
	"mB2": `Header-module__m-b-2___nyqlh`,
	"mB6": `Header-module__m-b-6___moiij`,
	"mB8": `Header-module__m-b-8___MTq9e`,
	"mB10": `Header-module__m-b-10___rz7pv`,
	"mB14": `Header-module__m-b-14___TwmcL`,
	"mB16": `Header-module__m-b-16___FiiEK`,
	"mB20": `Header-module__m-b-20___maA8s`,
	"mB22": `Header-module__m-b-22___DR8on`,
	"mB24": `Header-module__m-b-24___MV7m9`,
	"mB30": `Header-module__m-b-30___wMnFj`,
	"mB32": `Header-module__m-b-32___e_F1J`,
	"mB40": `Header-module__m-b-40___qhDfx`,
	"mT2": `Header-module__m-t-2___IMZ2c`,
	"mT3": `Header-module__m-t-3___EyncI`,
	"mT4": `Header-module__m-t-4___gMGZD`,
	"mT5": `Header-module__m-t-5___G_WB1`,
	"mT8": `Header-module__m-t-8___w3TbQ`,
	"mT10": `Header-module__m-t-10___nlwmQ`,
	"mT15": `Header-module__m-t-15___IE6dP`,
	"mT16": `Header-module__m-t-16___plD69`,
	"mT20": `Header-module__m-t-20___a9q8I`,
	"mT22": `Header-module__m-t-22___r2LQ3`,
	"mT30": `Header-module__m-t-30___VdU9z`,
	"mT32": `Header-module__m-t-32___YSBh9`,
	"mLAuto": `Header-module__m-l-auto___z_cwF`,
	"mL4": `Header-module__m-l-4___a78bg`,
	"mL5": `Header-module__m-l-5___UxcSd`,
	"mL6": `Header-module__m-l-6___e2833`,
	"mL8": `Header-module__m-l-8___J7nJe`,
	"mL10": `Header-module__m-l-10___m5rOI`,
	"mL16": `Header-module__m-l-16___X9OWn`,
	"mL20": `Header-module__m-l-20___sD81d`,
	"mL24": `Header-module__m-l-24___d7wWI`,
	"mL30": `Header-module__m-l-30___V7DwS`,
	"mL35": `Header-module__m-l-35___QvYm2`,
	"mL40": `Header-module__m-l-40___J70LO`,
	"mR8": `Header-module__m-r-8___Zk8Du`,
	"mR10": `Header-module__m-r-10___yBTsr`,
	"mR16": `Header-module__m-r-16___J2NSX`,
	"mR20": `Header-module__m-r-20____mJax`,
	"mR24": `Header-module__m-r-24___EE2J_`,
	"mR30": `Header-module__m-r-30___Btmfm`,
	"mR40": `Header-module__m-r-40___xynn2`,
	"borderR3": `Header-module__border-r-3___Mi2o3`,
	"borderR4": `Header-module__border-r-4___bt9pI`,
	"borderR6": `Header-module__border-r-6___mmls_`,
	"borderR10": `Header-module__border-r-10___CcYwb`,
	"borderR12": `Header-module__border-r-12___DGeRv`,
	"borderR16": `Header-module__border-r-16___PSyfv`,
	"borderR50": `Header-module__border-r-50___mII_D`,
	"primaryBorder": `Header-module__primary-border___Ijkp8`,
	"primaryBorderB": `Header-module__primary-border-b___q80F8`,
	"primaryBorderT": `Header-module__primary-border-t___Rt4kU`,
	"primaryBorderL": `Header-module__primary-border-l___tAd65`,
	"primaryBorderR": `Header-module__primary-border-r___IRnhw`,
	"secondaryBorder": `Header-module__secondary-border___GmEqg`,
	"secondaryBorderB": `Header-module__secondary-border-b___mkSrB`,
	"secondaryBorderT": `Header-module__secondary-border-t___bQPjS`,
	"secondaryBorderL": `Header-module__secondary-border-l___eeqs6`,
	"secondaryBorderR": `Header-module__secondary-border-r___m7fQj`,
	"gap0": `Header-module__gap-0___VV844`,
	"gap2": `Header-module__gap-2___rHayV`,
	"gap4": `Header-module__gap-4___e9DFS`,
	"gap5": `Header-module__gap-5___wiPFh`,
	"gap6": `Header-module__gap-6___lqGmn`,
	"gap8": `Header-module__gap-8___CpT_f`,
	"gap10": `Header-module__gap-10___g4Eko`,
	"gap12": `Header-module__gap-12___kEcX1`,
	"gap14": `Header-module__gap-14___P7p4W`,
	"gap16": `Header-module__gap-16___PFxAX`,
	"gap18": `Header-module__gap-18___GHYAh`,
	"gap20": `Header-module__gap-20___UM4vh`,
	"gap24": `Header-module__gap-24___fTvQN`,
	"gap26": `Header-module__gap-26___OhKR0`,
	"gap30": `Header-module__gap-30___Ht1bg`,
	"gap32": `Header-module__gap-32___PS58g`,
	"gap40": `Header-module__gap-40___LVR5v`,
	"gap50": `Header-module__gap-50___AEotQ`,
	"flex1": `Header-module__flex-1___x3qDH`,
	"flexNone": `Header-module__flex-none___wbOPq`,
	"flexColumn": `Header-module__flex-column___nDPPu`,
	"flexRow": `Header-module__flex-row___RopcY`,
	"verticallyCentered": `Header-module__vertically-centered___vhSxs`,
	"horizontallyCentered": `Header-module__horizontally-centered___d_Yn6`,
	"horizontallyEnd": `Header-module__horizontally-end___XzgiW`,
	"verticallyStart": `Header-module__vertically-start___qm6p3`,
	"spaceBetween": `Header-module__space-between___kBNcU`,
	"flexWrap": `Header-module__flex-wrap___qdItr`,
	"height100": `Header-module__height-100___vM7m7`,
	"width50": `Header-module__width-50___GwBBG`,
	"width100": `Header-module__width-100___Ds8gv`,
	"cursorPointer": `Header-module__cursor-pointer___JACtv`,
	"cursorNotAllowed": `Header-module__cursor-not-allowed___CYDzn`,
	"absoluteCentered": `Header-module__absolute-centered___sGDR5`,
	"absolute": `Header-module__absolute___zaeki`,
	"relative": `Header-module__relative___W7kVU`,
	"fixed": `Header-module__fixed___BOPg1`,
	"visible": `Header-module__visible___HDQi7`,
	"invisible": `Header-module__invisible___khVaH`,
	"col90": `Header-module__col-90___fosfH`,
	"colAuto": `Header-module__col-auto___3wAaL`,
	"medicalTabs": `Header-module__medical-tabs___VamLt`,
	"medicalTableNew": `Header-module__medical-table-new___wbkPn`,
	"noPagination": `Header-module__no-pagination___HHTpv`,
	"medicalTableEmpty": `Header-module__medical-table-empty___bjM4S`,
	"iconBtn": `Header-module__icon-btn___dosOP`,
	"searchIcon": `Header-module__search-icon___bhTTO`,
	"disableSelect": `Header-module__disable-select___cRmUi`,
	"breakWord": `Header-module__break-word___VjUbm`,
	"popupClearBtn": `Header-module__popup-clear-btn___ZSdaC`,
	"scrollMB20": `Header-module__scroll-m-b-20___sizLR`,
	"container": `Header-module__container___LLWyQ`,
	"title": `Header-module__title___op45E`,
	"buttonWrapper": `Header-module__buttonWrapper___yf0v8`,
	"icon": `Header-module__icon___o2Nz3`
};
module.exports = ___CSS_LOADER_EXPORT___;
